module.exports = __webpack_public_path__ + "img/1541504992.7f002c5b.jpg";